import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0D0D0D] border-t border-[#222222]">
      <div className="max-w-[1600px] mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-4 space-y-6">
            <img 
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/5b9bd2cbb4f3f977486d4a8e60efd124.jpeg" 
              alt="BillPlay Apparel" 
              className="h-16 w-auto"
            />
            <p className="text-sm text-gray-500 font-medium">
              Culture. Confidence. Community.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white hover:bg-white hover:text-black transition-all duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a 
                href="https://tiktok.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white hover:bg-white hover:text-black transition-all duration-300"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white hover:bg-white hover:text-black transition-all duration-300"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold text-white uppercase tracking-wide mb-6">SHOP</h4>
            <ul className="space-y-3">
              <li><Link to="/new-arrivals" className="text-sm text-gray-400 hover:text-white transition-colors">New Arrivals</Link></li>
              <li><Link to="/apparel" className="text-sm text-gray-400 hover:text-white transition-colors">Apparel</Link></li>
              <li><Link to="/footwear" className="text-sm text-gray-400 hover:text-white transition-colors">Footwear</Link></li>
              <li><Link to="/accessories" className="text-sm text-gray-400 hover:text-white transition-colors">Accessories</Link></li>
              <li><Link to="/sale" className="text-sm text-gray-400 hover:text-white transition-colors">Sale</Link></li>
            </ul>
          </div>

          {/* Support Column */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold text-white uppercase tracking-wide mb-6">SUPPORT</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/shipping" className="text-sm text-gray-400 hover:text-white transition-colors">Shipping Info</Link></li>
              <li><Link to="/returns" className="text-sm text-gray-400 hover:text-white transition-colors">Returns</Link></li>
              <li><Link to="/size-guide" className="text-sm text-gray-400 hover:text-white transition-colors">Size Guide</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold text-white uppercase tracking-wide mb-6">CONTACT</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:billplaycustoms@gmail.com" className="text-sm text-white hover:underline">
                  billplaycustoms@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+12699932813" className="text-sm text-white hover:underline">
                  (269) 993-2813
                </a>
              </li>
              <li>
                <p className="text-sm text-gray-500">
                  Northside, Kalamazoo, MI
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1A1A1A] bg-[#080808]">
        <div className="max-w-[1600px] mx-auto px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">
            © 2026 BillPlay Apparel. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-gray-600 hover:text-gray-400 transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-800">|</span>
            <Link to="/terms" className="text-xs text-gray-600 hover:text-gray-400 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}